import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { HandleBookingService } from '../../services/handle-booking.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { AuthService } from '../../../services/auth.service';
import { LoginComponent } from '../../../pages/login/login.component';

@Component({
    selector: 'app-manage-booking-modal',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        TranslocoModule
    ],
    providers: [HandleBookingService],
    templateUrl: './manage-booking-modal.component.html',
    styleUrls: ['./manage-booking-modal.component.css']
})
export class ManageBookingModalComponent implements OnInit {
    handleBookingGroup: any;

    constructor(
        public dialogRef: MatDialogRef<ManageBookingModalComponent>,
        private handleBookingService: HandleBookingService,
        private router: Router,
        private snackbar: SnackbarService,
        public authService: AuthService,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.handleBookingService.initForm('default');
        this.handleBookingGroup = this.handleBookingService.getForm().get('handleBookingGroup');
    }

    closeModal(): void {
        this.dialogRef.close();
    }

    goToHandleBookingForm(): void {
        if (!this.handleBookingGroup) return;
        const email = this.handleBookingGroup.controls['email']?.value;
        const booking_number = this.handleBookingGroup.controls['bookingNumber']?.value;
        if (email && booking_number) {
            this.handleBookingService.getBookingDetails(email, booking_number).subscribe({
                next: ((bookingDetails) => {
                    if (bookingDetails.orderStatus !== "Cancelled") {
                        this.dialogRef.close();
                        this.router.navigate(['parkifly/booking-overview', { email, booking_number }]);
                    } else {
                        this.snackbar.openSnackBar("Bokningen är inte giltig längre", 'Stäng');
                    }
                }),
                error: () => {
                    this.snackbar.openSnackBar("Ingen bokning hittades, la du bokningen nyss och betalade med kort kan det ta några minuter", 'Stäng');
                }
            });
        }
    }

    openLoginDialog(): void {
        this.dialogRef.close();
        if (this.authService.loggedIn()) {
            this.router.navigate(['parkifly/my-orders/flygets']);
        } else {
            this.dialog.open(LoginComponent, {
                width: '500px',
                disableClose: false,
                panelClass: 'login-dialog-panel',
                data: { forceMobileLayout: true, currentRoute: 'parkifly/my-orders/flygets' }
            });
        }
    }
}
